<template>
  <div class="fields">
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input fields " @click="focusRef" :class="hasValue">
      <input type="text"
             :class="inputClass"
             class="std-input"
             ref="input"
             v-model="content"
             :placeholder="title"
             v-on:input="checkAndUpdate"
             v-on:keydown="handleKeyDown"
             v-on:keypress="handleKeyPress"
      />
      <div class="icon">
        <img :src="icon">
      </div>
    </div>
  </div>
</template>

<script>
  import {
    hasValue,
    initializable,
    withErrors,
    withEventDispatcher,
    withIcon,
    withPlaceholder
  } from "./mixins/input.mixin";

  export default {
    name: "business-code-input",
    mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher, initializable],
    props: {
      title: String,
      icon: String,
      codeLength: Number,
    },
    methods: {
      handleKeyDown(e) {
        this.$emit('keydown', e)
      },
      handleKeyPress(e) {
        this.$emit('keypress', e)
      },
      focusRef() {
        this.$refs.input.focus();
        this.updateValue(this.content);
      },
      _computeErrors() {
        if ((typeof this.computeErrors === 'function')) {
          this.computeErrors();
        }
        this.$emit('compute-errors', this.content);
      },

      checkAndUpdate(e) {
        this.content = e.target.value.slice(0, this.codeLength).replace(/[^0-9]/g, '');
        this.updateValue(this.content);
      },

      updateValue(value) {
        this.content = value;
        this.$emit('input', value);
        if (this.useDynamicErrors) {
          this._computeErrors();
          return;
        }
        if (this.usePseudoDynamicErrors && this.hasError) {
          this._computeErrors();
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-code-input.vue